export default __webpack_public_path__ + "static/media/p58.5f23f2a6.jpg";